import type { LiveSheetItem } from "../../types/generated/live";

export type InventoryOp = { op: "upsert" | "update" | "remove"; collection: "inventory"; id: string; attrs?: Record<string, unknown> };

export function quantityAttrs(item: LiveSheetItem, quantity: number): Record<string, unknown> {
	const unitWeight = item.total_weight_grams / item.quantity;
	const attrs: Record<string, unknown> = { quantity, total_weight_grams: Math.round(unitWeight * quantity) };
	if (item.total_cost !== null) attrs.total_cost = (item.cost ?? 0) * quantity;
	return attrs;
}

export function reorderOps(ids: string[]): InventoryOp[] {
	return ids.map((id, index) => ({ op: "update", collection: "inventory", id, attrs: { position: index + 1 } }));
}
